import { render } from "./Menu.vue?vue&type=template&id=fe4da5ec&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=fe4da5ec&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Danka\\Desktop\\VUE PORTAL\\portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe4da5ec"]])

export default __exports__